import clsx from 'clsx'
import React, {useMemo} from 'react'
import {makeStyles} from 'external/material'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import CancelIcon from '@mui/icons-material/Cancel'
import ReplayIcon from '@mui/icons-material/Replay'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import ErrorIcon from '@mui/icons-material/Error'
import {STATUS_UPLOAD} from 'uploads/redux/constants'
import {viewerGuard} from 'helpers/url'

const useStyles = makeStyles(createStyles)

const UploadItem = props => {
  
  const { id, file, folder, progress, cancelSource, status } = props.file
  const {downloadServer} = props
  
  const contentLink = () => {
    return `${downloadServer}/${folder}/${file.name}`
  }
  
  const classes = useStyles()

  const renderIcon = useMemo(() => {
    const cancelUpload = () => {
      cancelSource.cancel('Cancelled by user')
    }

    if (status === STATUS_UPLOAD.uploading) {
      return (
        <span
          title="Cancel upload"
          onClick={cancelUpload}
        >
           <CancelIcon className={clsx(classes.wrapperItem, 'cancel')} focusable={true} />
        </span>
      )
    } else if (status === STATUS_UPLOAD.success) {
      return (
        <span 
          title="Success upload" 
          onClick={props.deleteUpload} 
          >
          <DeleteOutlinedIcon className={clsx(classes.wrapperItem, 'trash')} focusable={true} />
        </span>
      )
    } else if (status === STATUS_UPLOAD.failed) {
      return (
        <span
          title="Retry upload"
          style={{ color: 'orange' }}
          onClick={props.retryUpload}
        >
           <ReplayIcon className={clsx(classes.wrapperItem, 'retry')} focusable={true} />
        </span>
      )
    } else if (status === STATUS_UPLOAD.deleted) {
      return (
        <span
          title="Deleted upload"
          style={{ color: 'orange' }}
        >
          (DELETED)
        </span>
      )
    }

    return null
  }, [status])

  return (    
    <div className={clsx(classes.wrapperItem, {done: progress == 100})}>      
      <div className={clsx(classes.wrapperItem, 'leftside')}>
        {(progress == 100) &&
            <>
              <label>
                <AttachFileIcon style={{fill: '#10b1b2', height: 20}} />
                <a {...viewerGuard({href: contentLink(), target: "_blank"})} >{file.name}</a>
              </label>
            </>
        }
        {(progress < 100) &&
            <>
            <label className={classes.error}>
              <ErrorIcon style={{fill: 'red', height: 20, position: 'relative', height: 12 }} />
              {file.name}
            </label>
            </>
        }

        <div className={clsx(classes.wrapperItem, 'progressBar')}>          
          <div style={{ width: `${progress}%` }} />
        </div>        
      </div>
      <div className={clsx(classes.wrapperItem, 'rightside')}>
        {renderIcon}
        {/* <span className={clsx(classes.wrapperItem, 'percent')}>{progress}%</span> */}
      </div>
    </div>
  )
}

export default UploadItem


function createStyles(theme) {  
  return {
    root: {
      
    },
    error: {
      color: 'red'
    },
    wrapperItem: {
      display: 'grid',
      gridTemplateColumns: 'calc(100% - 50px) 50px',
      padding: '2px 0',
      '& .leftSide': {        
        display: 'grid',
        gridTemplateColumns: '100%',
        rowGap: '6px',
        marginRight: '12px',
        '& > label': {
          width: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          textAlign: 'left',
          padding: 0          
        }
      },      
      '& .rightSide': {
        display: 'grid',
        gridTemplateColumns: '100%',
        rowGap: '6px',
        marginRight: '12px',
        '& > span:first-child': {
          fontSize: '18px',
          cursor: 'pointer'
        }
      },
      '& .progressBar': {
        display: 'block',
        width: '100%',
        height: '15px',
        backgroundColor: 'lightgray',
        borderRadius: '20px',
        padding: '1px',
        marginTop: 3,
        '& > div': {
          height: '15px',
          backgroundColor: 'lightgreen',
          borderRadius: '20px',
          transition: 'width 1s'
        }
      },
      '&.done': {
        '& label': {
          padding: '0px !important',          
          backgroundColor: 'transparent',
          boxSizing: 'border-box'
        },
        '& .progressBar, & .percent': {
          display: 'none'
        }
      },
      '& .trash': {
        cursor: 'pointer',
        fontSize: 32,
        color: 'red'
      },
      '& .cancel': {
        cursor: 'pointer',
        fontSize: 32,
        color: 'red'
      },
      '& .retry': {
        cursor: 'pointer',
        fontSize: 32,
        color: 'orange'
      },
      '& svg': {
        height: 22
      }
    }
  }
}
